import React from 'react'
import {
  List, Datagrid, TextField, ReferenceField, DateField,
} from 'react-admin'

const EvaluationsList = (props) => (
  <List {...props}>
    <Datagrid rowClick="show">
      <ReferenceField label="Email" source="profileId" reference="accounts" target="id">
        <TextField source="email" />
      </ReferenceField>
      <DateField source="date" label="Date de l'évaluation" />
    </Datagrid>
  </List>
)

export default EvaluationsList
